import { render, staticRenderFns } from "./OrganizationsTable.vue?vue&type=template&id=caaa66fa&scoped=true&"
import script from "./OrganizationsTable.vue?vue&type=script&lang=ts&"
export * from "./OrganizationsTable.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationsTable.vue?vue&type=style&index=0&id=caaa66fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caaa66fa",
  null
  
)

export default component.exports